<template>
  <c-loader-status
    :loaders="{
      'no-initial-content': [
        vmtServiceViewModel.getVmtEventId,
        vmtServiceViewModel.getVmtToken,
      ],
    }"
  >
    <sj-vmt-widget
      v-if="vmtEventId && token"
      :mode="mode"
      :venue-id="venueId"
      :vmt-event-id="vmtEventId"
      :token="token"
      :reservation-id="reservationId"
      :seat-map-name="seatMapName"
      :section-only-selection="sectionOnlySelection"
      ref="sjVmtWidgetRef"
      @map-saved="emit('mapSaved', $event)"
      @inventory-change="emit('inventoryChange', $event)"
      @tickets-change="emit('ticketsChange', $event)"
      @close="emit('close')"
      :showTicketTypesTab="showTicketTypesTab"
      @seat-state-change="emit('seatStateChange', $event)"
    />
  </c-loader-status>
</template>

<script setup lang="ts">
import { VmtServiceViewModel } from "@/viewmodels.g";
import SjVmtWidget from "@common/components/sj-vmt-widget.vue";

const props = withDefaults(
  defineProps<{
    mode: "edit" | "inventory" | "picker";
    seatMapId: number;
    venueId: number;
    eventDateId?: number;
    eventId?: number;
    seatMapName?: string;
    reservationId?: string;
    showTicketTypesTab: boolean;
    sectionOnlySelection?: boolean;
  }>(),
  {
    showTicketTypesTab: true,
  },
);

const emit = defineEmits<{
  close: [];
  mapSaved: any;
  inventoryChange: any;
  ticketsChange: any;
  seatStateChange: [
    data: { seatIds: string[]; state: "selected" | "deselected" },
  ];
}>();

const vmtServiceViewModel = new VmtServiceViewModel();
vmtServiceViewModel.getVmtEventId.setConcurrency("debounce");
vmtServiceViewModel.getVmtToken.setConcurrency("debounce");
const sjVmtWidgetRef = ref<InstanceType<typeof SjVmtWidget> | null>(null);

const vmtEventId = computed(
  () => vmtServiceViewModel.getVmtEventId.result ?? null,
);
const token = computed(() => vmtServiceViewModel.getVmtToken.result ?? null);

async function load() {
  await vmtServiceViewModel.getVmtEventId(
    props.seatMapId,
    props.eventDateId ?? null,
    props.eventId ?? null,
    props.mode,
  );
  const eventId = vmtServiceViewModel.getVmtEventId.result;
  if (!eventId) return;
  await vmtServiceViewModel.getVmtToken(eventId, props.mode);
}

watch(
  [
    () => props.seatMapId,
    () => props.venueId,
    () => props.eventDateId,
    () => props.mode,
  ],
  () => load(),
  { immediate: true },
);

async function refresh() {
  await load();
  await sjVmtWidgetRef.value?.refresh();
}

async function pushRefreshCartSignal() {
  sjVmtWidgetRef.value?.pushRefreshCartSignal();
}

defineExpose({ refresh, pushRefreshCartSignal });
</script>
